import { render } from "./RegistroGeneradores.vue?vue&type=template&id=79d19b9e&scoped=true"
import script from "./RegistroGeneradores.vue?vue&type=script&lang=js"
export * from "./RegistroGeneradores.vue?vue&type=script&lang=js"

import "./RegistroGeneradores.vue?vue&type=style&index=0&id=79d19b9e&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d19b9e"]])

export default __exports__